import openFloatingModal from './openFloatingModal';
const openHtmlDocModal = (url, title) =>
  openFloatingModal(
    title,
    <iframe
      src={url}
      title={title}
      style={{ width: '100%', height: '70vh', border: 0 }}
    />
  );
export default openHtmlDocModal;